module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin-content"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "login-admin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit_input",
    on: {
      "click": function($event) {
        return _vm.adminLogin(_vm.username, _vm.password)
      }
    }
  }, [_c('label', [_vm._v("Log in")])])]) : _c('div', [_c('div', {
    staticClass: "admin-menu"
  }, [_c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.loadUsers();
        _vm.loadSettings();
        _vm.currentPage = 0
      }
    }
  }, [_vm._v("\n\t\t\t\tSETTNGS\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.loadCustomers();
        _vm.currentPage = 1
      }
    }
  }, [_vm._v("\n\t\t\t\tCUSTOMERS\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.currentPage = 2
      }
    }
  }, [_vm._v("\n\t\t\t\tAUDITION\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.currentPage = 3
      }
    }
  }, [_vm._v("\n\t\t\t\tFAQ\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.loadTexts();
        _vm.currentPage = 4
      }
    }
  }, [_vm._v("\n\t\t\t\tTexts\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.loadMembers();
        _vm.currentPage = 5
      }
    }
  }, [_vm._v("\n\t\t\t\tTeam Members\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        _vm.loadEmails();
        _vm.currentPage = 6
      }
    }
  }, [_vm._v("\n\t\t\t\tEmails\n\t\t\t")])]), _vm._v(" "), (_vm.currentPage == 0) ? _c('div', {
    attrs: {
      "id": "settings"
    }
  }, [_c('h3', [_vm._v("Admin users")]), _vm._v(" "), (_vm.users.length > 0) ? _c('div', {
    staticClass: "adminUsers"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      staticClass: "table-row"
    }, [_c('td', [_vm._v(_vm._s(user.user))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteUser(user.user)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tDelete\n\t\t\t\t")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "submit_input",
    on: {
      "click": function($event) {
        return _vm.registerNewUser(_vm.username, _vm.password)
      }
    }
  }, [_c('label', [_vm._v("Create new user")])])])])]), _vm._v(" "), (_vm.settings.length > 0) ? _c('div', {
    staticClass: "settings"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.settings), function(setting) {
    return _c('tr', {
      staticClass: "table-row"
    }, [_c('td', [_vm._v(_vm._s(setting.name))]), _vm._v(" "), _c('td', _vm._l((setting.options), function(soption) {
      return (setting.options.length > 0) ? _c('div', {
        staticClass: "table-value-Input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (setting.value),
          expression: "setting.value"
        }],
        attrs: {
          "type": "radio",
          "id": soption
        },
        domProps: {
          "value": soption + '#' + setting.options.join('#'),
          "checked": _vm._q(setting.value, soption + '#' + setting.options.join('#'))
        },
        on: {
          "change": function($event) {
            _vm.$set(setting, "value", soption + '#' + setting.options.join('#'))
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": soption
        }
      }, [_vm._v(_vm._s(soption))])]) : _c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (setting.value),
          expression: "setting.value"
        }],
        staticClass: "table-value-Input",
        attrs: {
          "autocomplete": "off"
        },
        domProps: {
          "value": (setting.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(setting, "value", $event.target.value)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.updateSettings(setting.name, setting.value)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tSave\n\t\t\t\t")])])])
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentPage == 1) ? _c('div', {
    attrs: {
      "id": "subscribed-customers"
    }
  }, [_c('h3', [_vm._v("Customers")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "height": "100%",
      "width": "450px",
      "border": "solid 1px #FF632B"
    }
  }, [_c('AddCustomer')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "height": "100%",
      "width": "450px",
      "border": "solid 1px #FF632B"
    }
  }, [_c('h3', [_vm._v("רישום לאודישן")]), _vm._v(" "), _c('Audition', {
    attrs: {
      "auditionType": _vm.chosenAudition
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.createCSV()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tיצא טבלה\n\t\t\t\t")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('site');
      }
    }
  }, [_vm._v("סניף")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('user_id');
      }
    }
  }, [_vm._v("מזהה יחודי")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('creation_time');
      }
    }
  }, [_vm._v("תאריך הוספה למערכת")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('name');
      }
    }
  }, [_vm._v("שם")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('instrument');
      }
    }
  }, [_vm._v("כלי ראשי")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('email');
      }
    }
  }, [_vm._v("מייל")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('phone');
      }
    }
  }, [_vm._v("טלפון")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('audition_type');
      }
    }
  }, [_vm._v("סוג אודישן")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('time');
      }
    }
  }, [_vm._v("רשום לאודישן")]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sortCustormersBy('deal_id');
      }
    }
  }, [_vm._v("מספר עסקה")])]), _vm._v(" "), _vm._l((_vm.customers), function(customer) {
    return _c('tr', {
      staticClass: "table-row"
    }, [_c('td', [_vm._v(_vm._s(customer.site))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.user_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(new Date(parseInt(customer.creation_time)).toString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.instrument))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.audition_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.booked_time ? (customer.time ? customer.day.split("T")[0] + " ,    " + customer.time : "") : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(customer.booked_time ? customer.deal_id : ""))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteCustomer(customer.user_id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tDelete\n\t\t\t\t")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.currentPage == 2) ? _c('div', {
    staticClass: "auditions"
  }, [_c('h3', [_vm._v("Auditions")]), _vm._v(" "), _c('table', {
    staticClass: "faqTable"
  }, [_c('tr', {
    staticClass: "table-row"
  }, [_c('td', [_c('h4', [_vm._v("קובץ הנחיות")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.audition_instructions,
      "target": "_blank"
    }
  }, [_c('h4', [_vm._v("לחץ כאן לצפיה בקובץ נוכחי")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadAuditionInstructions($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('AdminAudition')], 1) : _vm._e(), _vm._v(" "), (_vm.currentPage == 3) ? _c('div', {
    staticClass: "faqs"
  }, [_c('h3', [_vm._v("FAQS")]), _vm._v(" "), _c('h4', [_vm._v("Add faq")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faqQuestion),
      expression: "faqQuestion"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "Question"
    },
    domProps: {
      "value": (_vm.faqQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faqQuestion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td'), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faqAnswer),
      expression: "faqAnswer"
    }],
    staticClass: "faq_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "Answer"
    },
    domProps: {
      "value": (_vm.faqAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faqAnswer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "submit_input",
    on: {
      "click": function($event) {
        return _vm.postFAQ(_vm.faqQuestion, _vm.faqAnswer)
      }
    }
  }, [_c('label', [_vm._v("Add Faq")])])])])]), _vm._v(" "), (_vm.faqs.length > 0) ? _c('table', {
    staticClass: "faqTable"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.faqs), function(faq) {
    return _c('tr', {
      staticClass: "table-row"
    }, [_c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteFAQ(faq.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tDelete\n\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faq.question),
        expression: "faq.question"
      }],
      staticClass: "table-faq-Input",
      attrs: {
        "rows": "4",
        "cols": "50",
        "autocomplete": "off"
      },
      domProps: {
        "value": (faq.question)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faq, "question", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faq.answer),
        expression: "faq.answer"
      }],
      staticClass: "table-faq-Input",
      attrs: {
        "rows": "4",
        "cols": "50",
        "autocomplete": "off"
      },
      domProps: {
        "value": (faq.answer)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faq, "answer", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faq.rank),
        expression: "faq.rank"
      }],
      staticClass: "table-faq-Input2",
      attrs: {
        "autocomplete": "off"
      },
      domProps: {
        "value": (faq.rank)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faq, "rank", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.updateFAQ(faq.id, faq.question, faq.answer, faq.rank)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tSave\n\t\t\t\t\t")])])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentPage == 4) ? _c('div', {
    staticClass: "faqs"
  }, [_c('h3', [_vm._v("Texts")]), _vm._v(" "), _vm._l((_vm.texts), function(text, textName) {
    return _c('div', [_c('h2', [_vm._v(_vm._s(textName))]), _vm._v(" "), _c('table', {
      staticClass: "faqTable"
    }, [_vm._m(3, true), _vm._v(" "), _vm._l((text), function(subText, subTextName) {
      return _c('tr', {
        staticClass: "table-row"
      }, [_c('td', [_c('label', {
        staticClass: "table-faq-Input"
      }, [_vm._v(_vm._s(subText.textLabel))])]), _vm._v(" "), _c('td', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.texts[textName][subTextName].value),
          expression: "texts[textName][subTextName].value"
        }],
        staticClass: "table-faq-Input2",
        staticStyle: {
          "width": "600px",
          "height": "80px"
        },
        attrs: {
          "autocomplete": "off"
        },
        domProps: {
          "value": (_vm.texts[textName][subTextName].value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.texts[textName][subTextName], "value", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        on: {
          "click": function($event) {
            return _vm.updateTextTag(subText.textLabel, textName, subText.value)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\tSave\n\t\t\t\t\t")])])])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.currentPage == 5) ? _c('div', {
    staticClass: "faqs"
  }, [_c('h3', [_vm._v("TeamMembers")]), _vm._v(" "), _c('h4', [_vm._v("Add team member")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membername),
      expression: "membername"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "member name"
    },
    domProps: {
      "value": (_vm.membername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td'), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info),
      expression: "info"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "info"
    },
    domProps: {
      "value": (_vm.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picture),
      expression: "picture"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "picture"
    },
    domProps: {
      "value": (_vm.picture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.picture = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.song),
      expression: "song"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "song"
    },
    domProps: {
      "value": (_vm.song)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.song = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "login-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.position),
      expression: "position",
      arg: "value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.position = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("בחר קבוצה")]), _vm._v(" "), _vm._l((_vm.positionOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })], 2)])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "submit_input",
    on: {
      "click": function($event) {
        return _vm.postTeamMember(_vm.membername, _vm.title, _vm.info, _vm.picture, _vm.song, _vm.position)
      }
    }
  }, [_c('label', [_vm._v("Add TeamMember")])])])])]), _vm._v(" "), _vm._l((_vm.teamMembers), function(members, membersGroup) {
    return _c('div', [_c('h2', [_vm._v(_vm._s(membersGroup))]), _vm._v(" "), _c('table', {
      staticClass: "faqTable"
    }, [_vm._m(4, true), _vm._v(" "), _vm._l((members), function(member, index) {
      return _c('tr', {
        staticClass: "table-row"
      }, [_c('td', [_c('button', {
        on: {
          "click": function($event) {
            return _vm.deleteTeamMember(member.id)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\tDelete\n\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.teamMembers[membersGroup][index].membername),
          expression: "teamMembers[membersGroup][index].membername"
        }],
        staticClass: "login_input",
        attrs: {
          "rows": "4",
          "cols": "50",
          "autocomplete": "off"
        },
        domProps: {
          "value": (_vm.teamMembers[membersGroup][index].membername)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.teamMembers[membersGroup][index], "membername", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.teamMembers[membersGroup][index].title),
          expression: "teamMembers[membersGroup][index].title"
        }],
        staticClass: "login_input",
        attrs: {
          "rows": "4",
          "cols": "50",
          "autocomplete": "off"
        },
        domProps: {
          "value": (_vm.teamMembers[membersGroup][index].title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.teamMembers[membersGroup][index], "title", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.teamMembers[membersGroup][index].info),
          expression: "teamMembers[membersGroup][index].info"
        }],
        staticClass: "table-faq-Input",
        attrs: {
          "rows": "4",
          "cols": "50",
          "autocomplete": "off"
        },
        domProps: {
          "value": (_vm.teamMembers[membersGroup][index].info)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.teamMembers[membersGroup][index], "info", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [(_vm.picture != '') ? _c('img', {
        staticClass: "fillImg",
        attrs: {
          "alt": _vm.memberName,
          "src": member.picture
        }
      }) : _vm._e(), _c('br'), _vm._v(" "), _c('input', {
        attrs: {
          "type": "file",
          "name": "file"
        },
        on: {
          "change": function($event) {
            return _vm.uploadTeamObj($event.target.name, $event.target.files, 'picture', member.id)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('audio', {
        staticStyle: {
          "width": "200px"
        },
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": member.song,
          "type": "audio/mpeg"
        }
      }), _vm._v("\n\t\t\t\t\t\tYour browser does not support the audio element.\n\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('input', {
        attrs: {
          "type": "file",
          "name": "file"
        },
        on: {
          "change": function($event) {
            return _vm.uploadTeamObj($event.target.name, $event.target.files, 'song', member.id)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "login-select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model:value",
          value: (_vm.teamMembers[membersGroup][index].position),
          expression: "teamMembers[membersGroup][index].position",
          arg: "value"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.teamMembers[membersGroup][index], "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": ""
        }
      }, [_vm._v("בחר קבוצה")]), _vm._v(" "), _vm._l((_vm.positionOptions), function(option) {
        return _c('option', {
          domProps: {
            "value": option
          }
        }, [_vm._v(_vm._s(option))])
      })], 2)])]), _vm._v(" "), _c('td', [_c('button', {
        on: {
          "click": function($event) {
            return _vm.updateTeamMember(member.id, _vm.teamMembers[membersGroup][index].membername, _vm.teamMembers[membersGroup][index].title, _vm.teamMembers[membersGroup][index].info, _vm.teamMembers[membersGroup][index].picture, _vm.teamMembers[membersGroup][index].song, _vm.teamMembers[membersGroup][index].position)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\tSave\n\t\t\t\t\t")])])])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.currentPage == 6) ? _c('div', {
    staticClass: "faqs"
  }, [_c('div', {
    staticStyle: {
      "width": "800px"
    }
  }, [_c('h3', [_vm._v("Emails")]), _vm._v(" "), _c('h4', [_vm._v("Selected Emails")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "faqTable"
  }, [_vm._m(5), _vm._v(" "), _c('tr', {
    staticClass: "table-row"
  }, [_c('td', [_c('div', {
    staticClass: "login-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.contactMeSelected),
      expression: "contactMeSelected",
      arg: "value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contactMeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.emails), function(email) {
    return _c('option', {
      domProps: {
        "value": email.id
      }
    }, [_vm._v(_vm._s(email.email_name))])
  }), 0)])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "login-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.rhythmEmailSelected),
      expression: "rhythmEmailSelected",
      arg: "value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rhythmEmailSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.emails), function(email) {
    return _c('option', {
      domProps: {
        "value": email.id
      }
    }, [_vm._v(_vm._s(email.email_name))])
  }), 0)])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "login-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.ensambleEmailSelected),
      expression: "ensambleEmailSelected",
      arg: "value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ensambleEmailSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.emails), function(email) {
    return _c('option', {
      domProps: {
        "value": email.id
      }
    }, [_vm._v(_vm._s(email.email_name))])
  }), 0)])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        return _vm.saveSelectedEmails()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tUpdate\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-row"
  }, [_c('td', [_c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        return _vm.sendDummyContactMe()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tTest\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        return _vm.sendDummyRythemEmail()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tTest\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        return _vm.sendDummyEnsambleEmail()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tTest\n\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('h4', [_vm._v("Add email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailName),
      expression: "newEmailName"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "email name"
    },
    domProps: {
      "value": (_vm.newEmailName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.addEmail()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdd\n\t\t\t\t\t")]), _vm._v(" "), _c('h4', [_vm._v("Edit emails")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "faqTable"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.emails), function(email) {
    return _c('tr', {
      staticClass: "table-row"
    }, [_c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteEmail(email.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tDelete\n\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "menuButton admin-menuButton",
      on: {
        "click": function($event) {
          return _vm.editEmail(email)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(email.email_name) + "\n\t\t\t\t\t\t")])])])
  })], 2)])]), _vm._v(" "), (_vm.editedEmailId > 0) ? _c('div', {
    staticStyle: {
      "border": "solid",
      "max-width": "700px",
      "height": "1000px"
    }
  }, [_c('h3', [_vm._v("Email edit")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("email name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedEmailName),
      expression: "editedEmailName"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "email name"
    },
    domProps: {
      "value": (_vm.editedEmailName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedEmailName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("subject")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedEmailSubject),
      expression: "editedEmailSubject"
    }],
    staticClass: "login_input",
    attrs: {
      "autocomplete": "off",
      "placeholder": "email subject"
    },
    domProps: {
      "value": (_vm.editedEmailSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedEmailSubject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("email body")]), _c('br'), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedEmailText),
      expression: "editedEmailText"
    }],
    staticClass: "table-faq-Input",
    attrs: {
      "rows": "4",
      "cols": "50",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.editedEmailText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedEmailText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "faqTable"
  }, [_c('tr', [_c('th', [_c('button', {
    on: {
      "click": function($event) {
        return _vm.addAttachment()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdd\n\t\t\t\t\t")])]), _vm._v(" "), _c('th', [_vm._v("Attachments")])]), _vm._v(" "), _vm._l((_vm.editedEmailAttachments), function(attachment) {
    return _c('tr', {
      staticClass: "table-row"
    }, [_c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.removeEmailAttachment(attachment)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tDelete\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": attachment,
        "target": "_blank"
      }
    }, [_c('h4', [_vm._v(_vm._s(attachment))])]), _c('br'), _vm._v(" "), (attachment.length == 0) ? _c('input', {
      attrs: {
        "type": "file",
        "name": "file"
      },
      on: {
        "change": function($event) {
          return _vm.uploadEmailAttachment($event.target.name, $event.target.files)
        }
      }
    }) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "menuButton admin-menuButton",
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave Email Changes\n\t\t\t\t\t")])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("users")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("settingName")]), _vm._v(" "), _c('th', [_vm._v("Value")]), _vm._v(" "), _c('th', [_vm._v("Update")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Question")]), _vm._v(" "), _c('th', [_vm._v("Answer")]), _vm._v(" "), _c('th', [_vm._v("rank")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Value")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Info")]), _vm._v(" "), _c('th', [_vm._v("Picture")]), _vm._v(" "), _c('th', [_vm._v("Song")]), _vm._v(" "), _c('th', [_vm._v("Group")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("צרו איתי קשר")]), _vm._v(" "), _c('th', [_vm._v("רישום לאודישן רית'ם")]), _vm._v(" "), _c('th', [_vm._v("רישום לאודישן אנסמבל")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Email list -click to edit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2350a514!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin.vue
// module id = 105
// module chunks = 0